<template>
  <section class="housemaid-policy-form flex-1">
    <lazy-dom>
      <el-form
        ref="form"
        :rules="formRules"
        :disabled="showBuyable"
        :model="formData">
        <div
          v-if="isCancel"
          class="box">
          <h3></h3>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Cancellation Effective Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                :prop="checkRefer===1?'':'pcy_expry_dt'">
                <v-date-picker
                  v-model="formData.pcy_expry_dt"
                />
              </el-form-item>

            </div>
          </div>
        </div>
        <div class="box">
          <h2>Policy Details</h2>
          <div
            v-if="!isCancel"
            class="flex-sb">
            <div class="form-item form-half">
              <span>{{ isEndorsement? 'Endorsement Effective Date': 'Expected Effective Date' }}</span>
              <el-form-item
                ref="pcy_cmnt_dt"
                :prop="checkRefer===1?'':'pcy_cmnt_dt'">
                <v-date-picker
                  v-model="formData.pcy_cmnt_dt"
                  :_45daysComfirm='true'
                />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="!isCancel"
            class="form-item form-half">
            <span>Expected Expiry Date </span>
            <el-form-item
            >
              <v-date-picker
                :value="endDate"
                disabled/>
            </el-form-item>
          </div>
          <div
            v-if="isFamily"
            class="form-item form-half">
            <span>Quote Info</span>
            <el-form-item
            >
              <v-input
                :value="numOfTraveller"
                disabled/>
            </el-form-item>
          </div>
        </div>
        <div
          v-if="isRefer&&insuredItems.length>0"
          class="box">
          <h3>Insured Items</h3>
          <div class="form-item option_checkout">
            <v-checkbox-group
              v-model="formData.benefits"
              :isColumn="false"
              :list="insuredItems" />
          </div>
        </div>
        <div
          v-if="benefitList.length>0&&!isRefer"
          class="box">
          <!--          <h2>Insured Items</h2>-->
          <div
            class="form-item form-half option_checkout">
            <span>Insured Items</span>
            <el-form-item
            >
              <v-checkbox-group
                v-model="formData.benefits"
                :list="benefitList"
                :isColumn="false"
                @change="handlerExtra"
              />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <h2>Policyholder Details</h2>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Title</span>
              <el-form-item
                ref="isrd_title"
                prop="isrd_title">
                <v-select
                  v-model="formData.isrd_title"
                  :list="titleOptions"
                  :disabled="isCancel||checkDisabled('isrd_title')"
                />
              </el-form-item>
            </div>
          </div>
          <div class="form-item form-half">
            <span>Last Name</span>
            <el-form-item
              ref="isrd_lst_nm"
              prop="isrd_lst_nm">
              <v-input
                v-model="formData.isrd_lst_nm"
                uppercase
                :disabled="isCancel||checkDisabled('isrd_lst_nm')"
                @change="changeInsured"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>First Name</span>
            <el-form-item
              ref="isrd_fst_nm"
              prop="isrd_fst_nm">
              <v-input
                v-model="formData.isrd_fst_nm"
                uppercase
                :disabled="isCancel||checkDisabled('isrd_fst_nm')"
                @change="changeInsured"/>
            </el-form-item>
          </div>
          <div class="flex-sb">

            <div class="form-half">
              <div class="form-item">
                <span>{{formData.id_type==2?'Passport':'HKID'}} Number</span>
                <el-form-item
                  ref="id_type"
                >
                  <v-radio-group
                    v-model="formData.id_type"
                    :disabled="isCancel||checkDisabled('id_type')"
                    :list="personalIdTypOptions"
                    @change="changeInsured" />
                </el-form-item>
                <el-form-item
                  v-if="formData.id_type==1"
                  ref="id_no"
                >
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    placeholder="A123456(3), please input A1234563"
                    :disabled="isCancel||checkDisabled('id_no')"
                    class="mg-t-5"
                    @change="changeInsured" />
                </el-form-item>
                <el-form-item
                  v-else
                  ref="id_no"
                >
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    :disabled="isCancel||checkDisabled('id_no')"
                    class="mg-t-5" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Date of Birth</span>
                <el-form-item prop="isrd_dob">
                  <v-birth-day
                    v-model="formData.isrd_dob"
                    :disabled="isCancel||checkDisabled('isrd_dob')"
                    @change="changeInsured"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="form-item form-half">
            <span>Email</span>
            <el-form-item
              ref="email"
              :rules="rules.email"
              prop="email">
              <v-input
                v-model="formData.email"
                :disabled="isCancel||checkDisabled('email')"/>
            </el-form-item>
          </div>
          <div class="flex-sb">

            <div class="form-item form-half">
              <span>Mobile Number</span>
              <el-form-item
                ref="mobile_no"
                prop="mobile_no">
                <v-input
                  v-model="formData.mobile_no"
                  :disabled="isCancel||checkDisabled('mobile_no')"
                  type="number"/>
              </el-form-item>
            </div>
          </div>
          <div class="form-item form-half">
            <span>Occupation</span>
            <el-form-item prop="occ_id">
              <v-select
                v-model="formData.occ_id"
                :disabled="isCancel||checkDisabled('occ_id')"
                :list="localAllOptions.occupation"
                @change="changeInsured"/>
            </el-form-item>
          </div>
          <template v-if="isShowEmployer">
            <div class="flex-sb" >

              <div class="form-item form-half">
                <span>Name of Employer</span>
                <el-form-item
                  ref="employer_nm"
                  :rules="rules.name"
                  prop="employer_nm">
                  <v-input
                    v-model="formData.employer_nm"
                    uppercase
                    :disabled="isCancel||checkDisabled('employer_nm')"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="flex-sb">

              <div class="form-item form-half">
                <span>Nature of Business</span>
                <el-form-item
                  ref="employer_bsns_nature_id"
                  :rules="rules.select"
                  prop="employer_bsns_nature_id">
                  <v-select
                    v-model="formData.employer_bsns_nature_id"
                    :disabled="isCancel||checkDisabled('employer_bsns_nature_id')"
                    :list="localAllOptions.industry"/>
                </el-form-item>
              </div>
            </div>
          </template>
          <div class="form-item form-half">
            <span>Handedness</span>
            <el-form-item prop="occ_id">
              <v-select
                v-model="formData.handedness_id"
                :disabled="isCancel||checkDisabled('handedness_id')"
                :list="localAllOptions.handedness"/>
            </el-form-item>
          </div>
          <div
            v-if="isFamily"
            class="form-item">
            <span>Policyholder is one of the Insured?</span>
            <el-form-item
              ref="hldr_is_pa_ind"
              prop="hldr_is_pa_ind">
              <v-radio-group
                v-model="formData.hldr_is_pa_ind"
                :border="true"
                :list="yesNoOptions"
                :disabled="isFamily"
                @change="changeInsured" />
            </el-form-item>
          </div>
          <span class="title">Correspondence Address</span>
          <address-form
            ref="address-form"
            :formType="1"
            :formDataLock="formDataLock"
            :form="addressForm"
            :notValid="checkRefer===2?false:true"
            :disabled="isCancel||showBuyable"
            @getFormData="getAddressForm" />
          <section v-if="isShowEmployer">
            <span class="title">Office Address</span>
            <address-form
              ref="employer-address-form"
              :formType="1"
              :formDataLock="formDataLock"
              :form="employerAddressForm"
              :disabled="isCancel||showBuyable"
              @getFormData="getAddressForm" />
          </section>
        </div>

        <div
          v-if="isFamily"
          class="box">
          <h2>Insured Details</h2>
          <div class="insured-container">
            <div
              v-for="(item, index) in formData.nm_pa_list"
              :key="index"
              class="card"
            >
              <span class="title">Insured {{ index+1 }}</span>
              <div class="form-item">
                <span>Relationship with Policyholder</span>
                <el-form-item
                  :ref="`nm_pa_list.${index}.rel_id`"
                  :rules="rules.rel_id"
                  :prop="'nm_pa_list.' + index + '.rel_id'" >
                  <v-select
                    v-model="item.rel_id"
                    :list="
                      index == 0
                        ? relationOptionsSelf
                        : getRelationOptionsOther(item.age_type)
                    "
                    :is-select-first="index!=0"
                    :disabled="index == 0 && disabledHldrPa||true" />
                </el-form-item>
              </div>
              <template v-if="!(index == 0 && disabledHldrPa)">
                <div class="form-item">
                  <span>Title</span>
                  <el-form-item
                    :ref="'nm_pa_list.' + index + '.title'"
                    :rules="rules.title"
                    :prop="'nm_pa_list.' + index + '.title'" >
                    <v-select
                      v-model="item.title"
                      :list="carTitleOptions"
                      :disabled="index == 0 && disabledHldrPa" />
                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>Last Name</span>
                  <el-form-item
                    :ref="'nm_pa_list.' + index + '.lst_nm'"
                    :rules="rules.lst_nm"
                    :prop="'nm_pa_list.' + index + '.lst_nm'" >
                    <v-input
                      v-model="item.lst_nm"
                      uppercase
                      :disabled="index == 0 && disabledHldrPa" />
                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>First Name</span>
                  <el-form-item
                    :ref="'nm_pa_list.' + index + '.fst_nm'"
                    :rules="rules.fst_nm"
                    :prop="'nm_pa_list.' + index + '.fst_nm'" >
                    <v-input
                      v-model="item.fst_nm"
                      uppercase
                      :disabled="index == 0 && disabledHldrPa" />
                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>Date of Birth</span>
                  <el-form-item
                    :ref="'nm_pa_list.' + index + '.dob'"
                    :rules="rules.dob"
                    :prop="'nm_pa_list.' + index + '.dob'" >
                    <v-birth-day
                      v-model="item.dob"
                      :disabled="index == 0 && disabledHldrPa" />
                  </el-form-item>
                </div>
                <div class="form-item">
                  <!--            <span>HKID/Passport Number</span>-->
                  <el-form-item
                    :ref="'nm_pa_list.' + index + '.id_type'"
                    :rules="rules.id_type"
                    :prop="'nm_pa_list.' + index + '.id_type'" >
                    <v-radio-group
                      v-model="item.id_type"
                      :list="personalIdTypOptions"
                      :disabled="index == 0 && disabledHldrPa" />
                  </el-form-item>
                  <el-form-item
                    :ref="'nm_pa_list.' + index + '.id_no'"
                    :rules="rules.id_no"
                    :prop="'nm_pa_list.' + index + '.id_no'" >
                    <v-input
                      v-model="item.id_no"
                      class="mg-t-5"
                      uppercase
                      :placeholder="item.id_type==1?'A123456(3), please input A1234563':''"
                      :disabled="index == 0 && disabledHldrPa" />
                  </el-form-item>
                </div>
                <div class="form-item">
                  <span>Occupation</span>
                  <el-form-item
                    :ref="'nm_pa_list.' + index + '.occ_id'"
                    :rules="rules.occ_id"
                    :prop="'nm_pa_list.' + index + '.occ_id'" >
                    <v-select
                      v-model="item.occ_id"
                      :disabled="(index == 0 && disabledHldrPa) ||  item.age_type == 2"
                      :list="occupation(item.age_type)"/>
                  </el-form-item>
                </div>
              </template>
            </div>
          </div>
          <!--          <insured-base-info-form-->
          <!--            ref="insured-base-info-form"-->
          <!--            :formDataLock="formDataLock"-->
          <!--            :form="formData"-->
          <!--            :policyOneInsured="policyOneInsured"-->
          <!--            @getFormData="getSubFormData" />-->
        </div>

        <div class="box">
          <h2>Upload Document</h2>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Policyholder HKID</span>
              <el-form-item
                ref="id_type_pic_path_id"
                prop="id_type_pic_path_id">
                <v-upload
                  :card="true"
                  ::disabled="isCancel||showBuyable||checkDisabled(['id_no','id_type'])"
                  :fileData="formData.id_type_pic"
                  :otherData="{
                    target: 'id_type_pic',
                    idKey: 'id_type_pic_path_id',
                    nameKey: 'id_type_pic_path',
                  }"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
              </el-form-item>
            </div>
          </div>
          <div class="flex-sb">
            <div
              v-for="(item, index) in formData.nm_pa_list"
              v-show="!(index == 0 && disabledHldrPa)"
              :key="'pa-document-form-' + index"
              class=" form-half">
              <!--              <div class="document-title">-->
              <!--                <span class="label">Insured {{index+1}}</span>-->
              <!--              </div>-->
              <div class="form-item">
                <span>Insured {{index+1}} HKID/Passport</span>
                <el-form-item
                  :ref="`id_type_pic${index}`"
                  v-model="item.id_type_pic"
                  :name="`id_type_pic${index}`">
                  <v-upload
                    :card="true"
                    ::disabled="isCancel||showBuyable"
                    :fileData="item.id_type_pic"
                    :otherData="{
                      target: 'id_type_pic',
                      idKey: 'id_type_pic_path_id',
                      index,
                      nameKey: 'id_type_pic_path',
                      type:'pa'
                    }"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <!--        <div class="form-item">-->
          <!--          <span>Additional Documents</span>-->
          <!--          <file-container-->
          <!--            v-for="(item, index) in formData.other_file"-->
          <!--            :key="index"-->
          <!--            :fileData="item"-->
          <!--            :otherData="{-->
          <!--              index,-->
          <!--              type: 'other'-->
          <!--            }" -->
          <!--            :edit="true"-->
          <!--            @delete="handlerDeleteFile"-->
          <!--            @uploadSuccess="handlerUploadSuccess"-->
          <!--          />-->
          <!--          <v-upload-->
          <!--            :otherData="{-->
          <!--              type: 'other',-->
          <!--            }" -->
          <!--            @uploadSuccess="handlerUploadSuccess" />-->
          <!--        </div>-->
        </div>

      </el-form>
    </lazy-dom>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import AddressForm from '@/views/components/address-form'
import InsuredBaseInfoForm from '@/views/components/insured-base-info-form'

export default {
  name: 'PersonalPolicyForm',
  components: {
    AddressForm,
    // InsuredBaseInfoForm
  },
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props: {
    form: {
      type: Object,
      default: null
    },
    occData: {
      type: Object,
      default: () => ({})
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    editQuote:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkBirth3 = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.formData
      const birth = dayjs(pcy_cmnt_dt).format('YYYY-MM-DD') || ( Date.now() + 1000 * 60 * 60 * 24)
      let msTime = new Date(value).getTime()
      let above18 = dayjs(value).add(18, 'year').format('YYYY-MM-DD')
      // if(msTime > Date.now()) {
      //   callback( new Error( '出生日期不得大於當前日期' ) )
      // }
      if(new Date(above18).getTime() > new Date(birth).getTime()) {
        callback( new Error('申請人必須年滿18歲' ) )
      }
      callback()
    }
    return {
      formData: {
        benefits:[],
        handedness_id:'',
        age_id:'',
        occ_id:'',
        class_id: '',
        isrd_title: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        mobile_no: '',
        email: '',
        isrd_dob: '',
        isrd_dob_date: '',
        id_no: '',
        pcy_cmnt_dt: '',
        // pcy_expry_dt: '',

        id_type_pic_path: '',
        id_type_pic_path_id: '',
        id_type:1,
        other_file: [],
        id_type_pic: {},

        employer_nm:'',
        employer_bsns_nature_id:'',
        hldr_is_pa_ind: '',
        nm_pa_list:[]
      },
      formDataLock: 0,
      otherData: {},
      subForm: {
        'address-form': false,
        'employer-address-form': false,
        // 'insured-base-info-form': false,
      },
      addressForm: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      employerAddressForm: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      extraRules: {
        isrd_dob:[
          { validator: checkBirth3, trigger: ['blur'] }
        ],
        rel_id: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        title: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        lst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        fst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        dob: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_type: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        occ_id: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
      },
    }
  },
  computed: {
    isFamily(){
      let {type_of_insured} = this.form||{}
      return type_of_insured==2
    },
    numOfTraveller(){
      const { no_of_adult, no_of_child } = this.form
      const signAdult = 'Adult(s)'
      const signChild = 'Child(ren)'
      let text = no_of_child? `${no_of_adult} ${signAdult} · ${no_of_child} ${signChild}` : `${no_of_adult} ${signAdult}`
      return `Family, ${text}`
    },
    isShowEmployer(){
      let {occ_id} = this.formData||{}
      return ![220,246].includes(occ_id)
    },
    localAllOptions() {
      return this.allOptions27
    },
    insuredItems(){
      let {benefits=[]} = this.allOptions27
      return benefits||[]
    },
    endDate(){
      let {pcy_expry_dt,pcy_period,ins_end_dt}  =this.form
      let {pcy_cmnt_dt=''}  =this.formData
      let date = ''
      if(pcy_period==0)
        date = pcy_expry_dt
      else
        date=pcy_cmnt_dt? dayjs(pcy_cmnt_dt).add(pcy_period,'month').subtract(1,'day').format('YYYY-MM-DD'):''
      if(this.isEndorsement)
        return  ins_end_dt?ins_end_dt:pcy_expry_dt

      this.formData.pcy_expry_dt = date
      return date
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })

      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        // })
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
      // return this.rules
    },
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      if(this.editQuote){
        arr = JSON.parse(JSON.stringify(this[`allOptions${this.formData.class_id}`].benefits))
      }else{
        kyc_benefit.some(item=>{
          // if(item.is_selected==1)
          //   this.formData.benefits.push(item.id)
          if(item.is_show!==0){
            arr.push({name:item.name,id:item.id})
          }
        })
      }
      return arr||[]
    },
    policyOneInsured(){
      return this.formData.hldr_is_pa_ind == 1
    },
    occupation(){
      return (type)=>{
        let {child_occupation,occupation  } = this.localAllOptions||{}
        return type==2?child_occupation:occupation
      }
    },
    paItemDefault(){
      return {
        rel_id: '',
        title: '',
        lst_nm: '',
        fst_nm: '',
        id_no: '',
        id_type: 1,
        occ_id : '',
        id_type_pic_path: '',
        id_type_pic_path_id: '',
        id_type_pic_url: '',
        id_type_pic_thumb_url: '',
        id_type_pic: null,
      }
    },
    disabledHldrPa(){
      const { hldr_is_pa_ind } = this.form || {}
      return hldr_is_pa_ind == 1
    },
    occOptionsAdult(){
      const { occupation } = this.localAllOptions || {}
      return occupation || []
    },
    occOptionsChild(){
      const { child_occupation } = this.localAllOptions || {}
      return child_occupation || []
    },
    relationOptions(){
      const { relation } = this.localAllOptions || {}
      return relation || []
    },
    relationOptionsSelf(){
      return this.relationOptions.filter(v => v.id == 1)
    },
    relationOptionsAdult(){
      return this.relationOptions.filter(v => v.id == 2)
    },
    relationOptionsChild(){
      return this.relationOptions.filter(v => v.id == 3)
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          const formValue = JSON.parse(JSON.stringify(val))
          this.formData = Object.assign(
            this.formData,
            formValue
          )
          let {quote_coverage_list} = val||{}
          let {kyc_benefit=[]} = quote_coverage_list||{}
          kyc_benefit.some(item=>{
            if(item.is_selected==1)
              this.formData.benefits.push(item.id)
          })
          this.formData.benefits= [...new Set( this.formData.benefits)]
          // if(formValue.id_type != 1) {
          //   this.formData.id_no = ''
          // }
          if(formValue.id_type_pic) {
            const { path, id } = val.id_type_pic
            this.formData.id_type_pic_path = path
            this.formData.id_type_pic_path_id = id
          }
          this.handler().handlerAddress(formValue)
          this.handlerInitNmPaList(val)
          if(this.isFamily){
            this.initFirstInsured()
          }
        }
      }
    },
    occData: {
      immediate: true,
      handler(val) {
        let {cust_typ} = this.form
        let keys = {
          isrd_title: '',
          isrd_lst_nm: '',
          isrd_dob: '',
          isrd_fst_nm: '',
          id_type: '',
          id_no: '',
          mobile_no: '',
          email: '',
          isrd_dob_date: '',
        }
        if (val) {
          Object.keys(keys).some(key => {
            if (key in val) {
              if(val[key])
                this.formData[key] = val[key]
            }
          })
        }
        if(val.phone)
          this.formData.mobile_no = val.phone
      }
    }
  },
  methods: {
    getRelationOptionsOther(age_type){
      if(age_type == 1){
        return this.relationOptionsAdult
      }else if(age_type == 2){
        return this.relationOptionsChild
      }
      return []
    },
    initFirstInsured(){
      const {isrd_title, isrd_lst_nm, isrd_fst_nm, id_no, isrd_dob, id_type, occ_id,id_type_pic = {}} = this.form||{}
      const {id, path, url, thumb_url} = id_type_pic || {}

      const firstInsured = this.formData.nm_pa_list[0] || {}

      let result = {
        ...this.paItemDefault,
        ...firstInsured,
        rel_id: 1,
        title: isrd_title,
        lst_nm: isrd_lst_nm,
        fst_nm: isrd_fst_nm,
        id_no: id_no,
        id_type: id_type,
        dob: isrd_dob,
        occ_id,
        id_type_pic_path: path,
        id_type_pic_path_id: id,
        id_type_pic_url: url,
        id_type_pic_thumb_url: thumb_url,
        id_type_pic: id_type_pic,
      }



      this.$set(this.formData.nm_pa_list, 0, result)
    },
    handlerInitNmPaList(data){
      if(!this.isFamily) return
      const { nm_pa_list } = data || {}
      const paList = nm_pa_list || []
      let arr = []
      console.log('data--',data)
      paList.forEach(item => {
        const { id_type_pic_path, id_type_pic_url, id_type_pic_path_id} = item
        arr.push({
          ...this.paItemDefault,
          ...item,
          id_type_pic : {
            path : id_type_pic_path,
            url : id_type_pic_path,
            thumb_url : id_type_pic_path,
          }
        })
      })
      this.formData.nm_pa_list = arr
      console.log('nm_pa_list--',arr)
    },

    handlerExtra(){
      let {extra_benefits,pcy_cmnt_dt,benefits} = this.formData
      let params = {
        extra_benefits,
        pcy_cmnt_dt,
        benefits
      }
      this.$emit('changeCompute',params)
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      if(typeof(field) != 'string'){
        let res = false
        field.map(item => {
          if(disable_filed.includes(item)){
            res = true
          }
        })
        return res
      }
      return disable_filed.includes(field)&&!!this.form[field]
    },
    getAddressForm(form, data) {
      // debugger
      this.subForm[form] = true
      if(form == 'employer-address-form') {
        this.handler().handlerAddressResult(data)
      }
      else
        this.formData = Object.assign(this.formData, data)
    },
    submitForm(otherData = {}) {
      let subForm = this.subForm
      if(!this.isShowEmployer){
        delete subForm['employer-address-form']
      }
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          Object.keys(subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if (Object.values(subForm).some(item => item === false)) {
            return
          }
          let {benefits=[]} = this.formData||{}
          const uniqueArray = benefits.filter((value, index, self) => {
            return self.indexOf(value) === index
          })
          const result = {
            ...this.formData,
            benefits:uniqueArray
          }
          this.$emit('getFormData', result, otherData)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },
    getSaveSubmitForm(otherData = {}){
      this.otherData = otherData
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitFormNoVaild(key)
      })
      let {benefits=[]} = this.formData||{}
      const uniqueArray = benefits.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
      const result = {
        ...this.formData,
        benefits:uniqueArray
      }
      this.$emit('getFormData', result, otherData)
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path } = data
      if(type !== 'other'&&type!='pa') {
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, 'id_type_pic', data)
        this.$set(this.formData, nameKey, path)
        // this.$set(this.formData, target, data)
        this.$refs['form'].validateField(idKey)
      }
      else if(type=='pa'){
        this.$set(this.formData.nm_pa_list[index], target, data)
        this.$set(
          this.formData.nm_pa_list[index],
          `${target}_path`,
          data.name
        )
        this.$set(
          this.formData.nm_pa_list[index],
          `${target}_path_id`,
          data.id
        )
        this.$set(
          this.formData.nm_pa_list[index],
          `${target}_url`,
          data.url
        )
      }
      else {
        if(index === '') {
          this.formData.other_file.push(data)
        }
        else {
          this.$set(this.formData.other_file, index, data)
        }
      }
    },
    handlerDeleteFile({otherData}) {
      const { type, index } = otherData
      this.$set(this.formData, 'id_type_pic_path_id', '')
      this.$set(this.formData, 'id_type_pic', {})

    },
    handler() {
      return {
        handlerAddress: (data) => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region,
            office_addr_room,
            office_addr_floor,
            office_addr_block,
            office_addr_building,
            office_addr_street,
            office_addr_district,
            office_addr_area,
            office_addr_region,
          } = data
          const obj = {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          }
          const employerObj = {
            addr_room:office_addr_room,
            addr_floor:office_addr_floor,
            addr_block:office_addr_block,
            addr_building:office_addr_building,
            addr_street:office_addr_street,
            addr_district:office_addr_district,
            addr_area:office_addr_area,
            addr_region:office_addr_region,
          }
          const params = {}
          Object.keys(this.addressForm).some(key => {
            params[key] = data[key]
          })

          this.formDataLock += 1
          this.addressForm = JSON.parse(JSON.stringify(obj))
          console.log('this.addressForm-',this.addressForm)
          this.employerAddressForm = JSON.parse(JSON.stringify(employerObj))
        },
        handlerAddressResult: data => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const params = {
            office_addr_room: addr_room,
            office_addr_floor: addr_floor,
            office_addr_block: addr_block,
            office_addr_building: addr_building,
            office_addr_street: addr_street,
            office_addr_district: addr_district,
            office_addr_area: addr_area,
            office_addr_region: addr_region
          }
          Object.assign(this.formData, params)
        }
      }
    },
    getSubFormData(form, data) {
      this.subForm[form] = true
      this.formData = Object.assign(this.formData, data)
    },
    changeInsured() {
      const {
        id_no, id_type, isrd_dob, isrd_fst_nm, isrd_lst_nm, isrd_title, occ_id,hldr_is_pa_ind,
        id_type_pic
      } = this.formData||{}

      const { id, path } = id_type_pic || {}
      // 避免二次觸發 form 數據更新，影響 document 組件 司機數據
      if(hldr_is_pa_ind == 1) {

        Object.assign(this.formData.nm_pa_list[0], {
          rel_id: 1,
          dob: isrd_dob,
          fst_nm: isrd_fst_nm,
          id_no: id_no,
          id_type: id_type,
          lst_nm: isrd_lst_nm,
          occ_id: occ_id,
          title: isrd_title,
          id_type_pic_path_id: id,
          id_type_pic_path: path,
          id_type_pic: id_type_pic,
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.option_checkout{
  ::v-deep .el-checkbox-group{
    flex-direction: column;
    align-items: flex-start;
  }
}
.document-title {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  color: #677FA1;
  .label {
    padding-right: 8px;
    font-weight: 500;
    color: #000;
    white-space: nowrap;
  }
}
</style>
